import _ from 'lodash';

const initialState = {};

export const NAME = 'resources.scheduledReports';

export default function reducer(state = initialState, action) {
    switch (action.type) {
        default:
            return state;
    }
}
